module.exports = __webpack_public_path__ + "media/man4.b47072cb.wav";